module.exports = __webpack_public_path__ + "img/12.13b31490.jpg";